import { arrayUnion, doc, updateDoc } from "firebase/firestore";
import { db } from "../Firebase/firebase";

const addOrRemoveFavorites = async (e, productId, userId, favoritesList) => {
  e.stopPropagation()
  const docRef = doc(db, "users", userId);
  const stringId = productId.toString();
  const newList = favoritesList.filter((item) => item !== stringId);
  const mapped = favoritesList?.map((it) => it);
  //   console.log(mapped);
  if (favoritesList?.includes(stringId)) {
    try {
      await updateDoc(docRef, {
        favorites: newList,
      });
    } catch (err) {
      console.log(err);
    }
    console.log(`removed ${stringId}`);
  } else {
    try {
      await updateDoc(docRef, {
        favorites: arrayUnion(stringId),
      });
      console.log("list updated");
    } catch (err) {
      console.log(err);
    }
  }
};

export default addOrRemoveFavorites;
